import { Injectable, Signal } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { LoadingSpinnerComponent } from '../../components/loading-spinner/loading-spinner.component'; // eslint-disable-line
import { toSignal } from '@angular/core/rxjs-interop'; // being used for JSDoc reference

/**
 * Used in conjunction with `<r1-loading-spinner />`
 * @see {@link LoadingSpinnerComponent}
 */
@Injectable({
    providedIn: 'root',
})
export class SpinnerService {
    private _isLoading = new BehaviorSubject<boolean>(false);
    private _runningProcesses: BehaviorSubject<Map<string, string>> = new BehaviorSubject(new Map());

    loading: Signal<boolean> = toSignal(this.isLoading(), { initialValue: false });
    loadingMessages: Signal<string[]> = toSignal(this.getMessages(), { initialValue: [] });

    addProcess(key: string, message: string): void {
        const runningProcesses = this._runningProcesses.getValue();
        runningProcesses.set(key, message);
        this._runningProcesses.next(runningProcesses);
        this._isLoading.next(true);
    }

    completeProcess(key: string): void {
        const value = this._runningProcesses.getValue();
        value.delete(key);
        this._runningProcesses.next(value);
        this._isLoading.next(value.size > 0);
    }

    clearProcesses(): void {
        this._runningProcesses.next(new Map());
        this._isLoading.next(false);
    }

    isLoading(): Observable<boolean> {
        return this._isLoading.asObservable();
    }

    getMessages(): Observable<string[]> {
        return this._runningProcesses.pipe(map(runningProcesses => Array.from(runningProcesses.values())));
    }
}
